export enum PosterZoomModes {
  POSTER = 'POSTER',
  TIMELINES = 'TIMELINES',
}
